import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <section className="about-header section" aria-labelledby="about-title">
        <div className="container">
          <h1 id="about-title">हमारे बारे में</h1>
          <p className="about-subtitle">भारत की सबसे विश्वसनीय राजनीतिक समाचार वेबसाइट</p>
        </div>
      </section>

      <section className="about-content section primary">
        <div className="container">
          <div className="about-grid">
            <div className="about-section">
              <h2>लाठ साब की कहानी</h2>
              <p>
                लाठ साब की स्थापना २०२० में की गई थी, जब भारतीय समाचार परिदृश्य में एक विश्वसनीय और निष्पक्ष समाचार स्रोत की आवश्यकता थी। हमारा उद्देश्य राजनीतिक समाचारों को सरल, स्पष्ट और हर किसी के लिए सुलभ बनाना है।
              </p>
              <p>
                हमारी टीम अनुभवी पत्रकारों, विश्लेषकों और संपादकों से मिलकर बनी है, जो भारतीय राजनीति और समाज को गहराई से समझते हैं।
              </p>
            </div>

            <div className="about-section">
              <h2>हमारा मिशन</h2>
              <ul className="mission-list">
                <li>✅ निष्पक्ष और सटीक समाचार प्रदान करना</li>
                <li>✅ राजनीतिक विश्लेषण और गहन रिपोर्टिंग</li>
                <li>✅ सभी को सूचित और जागरूक रखना</li>
                <li>✅ लोकतांत्रिक मूल्यों को प्रोत्साहित करना</li>
                <li>✅ पारदर्शिता और ईमानदारी बनाए रखना</li>
              </ul>
            </div>

            <div className="about-section">
              <h2>हमारी टीम</h2>
              <div className="team-grid">
                <div className="team-member">
                  <div className="member-avatar">📰</div>
                  <h4>राज कुमार</h4>
                  <p>मुख्य संपादक</p>
                </div>
                <div className="team-member">
                  <div className="member-avatar">👨‍💼</div>
                  <h4>प्रिया शर्मा</h4>
                  <p>वरिष्ठ संवाददाता</p>
                </div>
                <div className="team-member">
                  <div className="member-avatar">📊</div>
                  <h4>अमित वर्मा</h4>
                  <p>विश्लेषक</p>
                </div>
              </div>
            </div>

            <div className="about-section">
              <h2>हमारे मूल्य</h2>
              <div className="values-grid">
                <div className="value-card">
                  <h4>सत्य</h4>
                  <p>हम केवल सत्यापित तथ्यों पर आधारित समाचार प्रकाशित करते हैं।</p>
                </div>
                <div className="value-card">
                  <h4>निष्पक्षता</h4>
                  <p>हम किसी भी राजनीतिक पक्ष से पूरी तरह स्वतंत्र हैं।</p>
                </div>
                <div className="value-card">
                  <h4>पारदर्शिता</h4>
                  <p>हम अपने स्रोत और विधियों के बारे में खुले हैं।</p>
                </div>
                <div className="value-card">
                  <h4>जवाबदेही</h4>
                  <p>हम अपनी त्रुटियों के लिए जिम्मेदारी लेते हैं और सुधार करते हैं।</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
